import { Component, inject, Input } from '@angular/core';
import { IProduct } from '../../model/product.model';
import { Store } from '@ngrx/store';
import { AppState, selectAllNonFavoriteScenarios, selectFavouriteScenarios } from 'src/app/store';
import { filter } from 'rxjs';
import { Helpers } from "../../../../core/shared/helpers";
import { ConfigAwareService } from '../../../../core/config/models/config';

@Component({
    selector: 'app-product-top-nav',
    templateUrl: './product-top-nav.component.html',
    styles: `
    :host {
      display: block;
    }
  `,
    standalone: false
})
export class ProductTopNavComponent extends ConfigAwareService {
  @Input() product: IProduct;

  private store: Store<AppState> = inject(Store);
  protected favouriteScenarios$ = this.store.select(selectFavouriteScenarios).pipe(filter(scenarios => !!scenarios?.length));
  protected scenarios$ = this.store.select(selectAllNonFavoriteScenarios).pipe(filter(scenarios => !!scenarios?.length));

  protected readonly Helpers = Helpers;

  get modelManagerUrl(): string {
    const baseUrl = this.appConfig.ramp.env === 'pfm-prod-v2' ? 'https://registry.kohort.dev' : 'https://registry.staging.kohort.dev';
    return `${baseUrl}/admin/training-job/list?page=0&search=${this.product.id}`;
  }

  get ingestionUrl(): string {
    const baseUrl = this.appConfig.ramp.env === 'pfm-prod-v2' ? 'https://ingestion.kohort.dev' : 'https://ingestion.staging.kohort.dev';
    return `${baseUrl}/admin/data_schema/product/${this.product.id}/change/?_changelist_filters=q%3D${this.product.id}`;
  }
}
